import { z } from 'zod';
import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
const DirectMessageReceivedInboundSchema = z
    .object({
    conversationPlayer: z.string().transform(playerIdNameParser),
    fromPlayer: z.string().transform(playerIdNameParser).optional(),
    messageId: z.number(),
    messageHtml: z.string()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'privatemsg',
    ...rest
}));
export const DIRECT_MESSAGE_RECEIVED_PAYLOAD_DEFINITION = {
    zodSchema: DirectMessageReceivedInboundSchema
};
